<p>
    Import vehicles from remote Cartegraph server.
</p>

@if (currentState === ImportVehiclesStateEnum.NOOP && uiError) {
	<div class="ui-error">
		Error while processing the request: {{ uiError }}
	</div>
}
@if (currentState === ImportVehiclesStateEnum.IMPORTED) {
	<div>
		<mat-accordion>
			@for (key of importKeys; track key) {
				<mat-expansion-panel>
					<mat-expansion-panel-header>
						<mat-panel-title>
							{{key.label}}: {{importResult[key.name]?.length || 0}}
						</mat-panel-title>
					</mat-expansion-panel-header>
					<ol>
						@for (row of importResult[key.name]; track row.key) {
							<li>{{row.key}}
								@if (key.name === 'error') {
									<span class="mat-small">{{row.note}}</span>
								}
							</li>
						}
					</ol>
				</mat-expansion-panel>
			}
		</mat-accordion>
	</div>
}
